import FnEditorElement from "../FnEditorElement";
export default class RemoveElementAction {
    constructor(id) {
        this.id = id;
        this.type = 'removeElement';
        this.text = null;
        this.afterId = null;
    }
    apply(state, dom, logger) {
        var _a, _b, _c, _d;
        if (this.afterId === null) {
            this.afterId = ((_a = state.elements.getPreviousOf(this.id)) === null || _a === void 0 ? void 0 : _a.getId()) || null;
        }
        if (this.text === null) {
            this.text = ((_b = state.elements.getById(this.id)) === null || _b === void 0 ? void 0 : _b.getText()) || '';
        }
        const idsToEvaluate = [];
        const prevId = (_c = state.elements.getPreviousOf(this.id)) === null || _c === void 0 ? void 0 : _c.getId();
        if (prevId) {
            idsToEvaluate.push(prevId);
        }
        const nextId = (_d = state.elements.getNextOf(this.id)) === null || _d === void 0 ? void 0 : _d.getId();
        if (nextId) {
            idsToEvaluate.push(nextId);
        }
        state.elements.removeById(this.id);
        dom.removeById(this.id);
        return {
            idsToEvaluate
        };
    }
    undo(state, dom, logger) {
        var _a, _b, _c;
        const domElement = dom.insertAfter(this.id, (_a = this.afterId) !== null && _a !== void 0 ? _a : undefined);
        const element = new FnEditorElement(this.id, (_b = this.text) !== null && _b !== void 0 ? _b : '');
        state.elements.insertAfter(element, (_c = this.afterId) !== null && _c !== void 0 ? _c : undefined);
        element.syncWithDom(domElement);
        return {
            idsToEvaluate: [this.id]
        };
    }
    getDataToMergeWithNext(nextType) {
        return {};
    }
    mergeWithPrevious(previousType, previousData) {
        return false;
    }
}
